const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/login",
    exact: true,
    component: "Login",
  },
  {
    path: "/dashboard",
    exact: false,
    component: "Dashboard",
  },
];

export default routes;
